// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Js_dict from "../../../node_modules/rescript/lib/es6/js_dict.js";
import * as Caml_obj from "../../../node_modules/rescript/lib/es6/caml_obj.js";
import * as Belt_Array from "../../../node_modules/rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_option from "../../../node_modules/rescript/lib/es6/caml_option.js";
import * as CSS$Showside from "./utils/CSS.bs.js";
import * as NavSDK$Showside from "./utils/NavSDK.bs.js";
import * as Category$Showside from "./types/Category.bs.js";
import * as InjectJS$Showside from "./components/InjectJS.bs.js";
import * as Location$Showside from "./utils/Location.bs.js";
import * as InjectCSS$Showside from "./components/InjectCSS.bs.js";
import * as EmbedTypes$Showside from "./types/EmbedTypes.bs.js";
import * as LCPContext$Showside from "./context/LCPContext.bs.js";
import * as NavMenuApp$Showside from "./apps/NavMenuApp.bs.js";
import * as WebapiUtils$Showside from "./utils/WebapiUtils.bs.js";
import * as Webapi__Dom__Element from "../../../node_modules/rescript-webapi/lib/es6_global/src/Webapi/Dom/Webapi__Dom__Element.bs.js";
import * as AdditionalCSS$Showside from "./components/AdditionalCSS.bs.js";
import * as BaseWithTheme$Showside from "./context/BaseWithTheme.bs.js";
import * as EditorMethods$Showside from "./components/EditorMethods.bs.js";
import * as ErrorBoundary$Showside from "./utils/ErrorBoundary.bs.js";
import * as ErrorReporter$Showside from "./components/ErrorReporter.bs.js";
import * as ReactDOMUtils$Showside from "./utils/ReactDOMUtils.bs.js";
import * as StoreProvider$Showside from "./context/StoreProvider.bs.js";
import * as WipeDOMEvents$Showside from "./utils/WipeDOMEvents.bs.js";
import * as ConfigIdGetter$Showside from "./ConfigIdGetter.bs.js";
import * as LocationConfig$Showside from "./utils/LocationConfig.bs.js";
import * as NavMenu__Types$Showside from "./components/NavMenu/NavMenu__Types.bs.js";
import * as PortalEmptying$Showside from "./utils/PortalEmptying.bs.js";
import * as RouterProvider$Showside from "./context/RouterProvider.bs.js";
import * as RollbarInstance$Showside from "./utils/RollbarInstance.bs.js";
import * as ViewportContext$Showside from "./context/ViewportContext.bs.js";
import * as MutationObserver$Showside from "./utils/MutationObserver.bs.js";
import * as NavMenu__Context$Showside from "./components/NavMenu/NavMenu__Context.bs.js";
import * as ShopifyAnalytics$Showside from "./utils/ShopifyAnalytics.bs.js";
import * as ConditionalRender$Showside from "./utils/ConditionalRender.bs.js";
import * as NavMenu__Settings$Showside from "./components/NavMenu/NavMenu__Settings.bs.js";
import * as RefByQuerySelector$Showside from "./utils/RefByQuerySelector.bs.js";
import * as CartContextProvider$Showside from "./context/CartContextProvider.bs.js";
import * as CriticalCSSProvider$Showside from "./context/CriticalCSSProvider.bs.js";
import * as ConfigurationProvider$Showside from "./context/ConfigurationProvider.bs.js";
import * as NavMenu__PreloadHelpers$Showside from "./components/NavMenu/NavMenu__PreloadHelpers.bs.js";
import * as UserSavedProductsProvider$Showside from "./context/UserSavedProductsProvider.bs.js";
import * as StickyHeaderOffsetProvider$Showside from "./context/StickyHeaderOffsetProvider.bs.js";
import * as ExternalIntegrationProvider$Showside from "./context/ExternalIntegrationProvider.bs.js";
import * as UseDocumentReadyStateChange$Showside from "./hook/UseDocumentReadyStateChange.bs.js";
import * as PictureInPicture2SessionStorage$Showside from "./utils/PictureInPicture2SessionStorage.bs.js";
function useTarget(attributes, embedElement, mode, isIndexAllowed, param) {
  var match = ConfigurationProvider$Showside.use(undefined);
  var config = match.config;
  var match$1 = RouterProvider$Showside.useRouter(undefined);
  var goTo = match$1.goTo;
  var navMenuConfig = NavMenu__Settings$Showside.useSettings(attributes);
  var getTargetSelector = function (mode) {
    if (mode) {
      return Belt_Option.flatMap(navMenuConfig, function (config) {
        return config.hamburgerTarget;
      });
    } else {
      return Belt_Option.flatMap(navMenuConfig, function (config) {
        return config.topbarTarget;
      });
    }
  };
  var getTriggerButtonSelector = function (mode) {
    return Belt_Option.flatMap(attributes, function (attr) {
      if (mode) {
        return Belt_Option.flatMap(navMenuConfig, function (config) {
          return config.hamburgerTriggerButtonTarget;
        });
      }
    });
  };
  var getTargetStyle = function (mode) {
    return Belt_Option.flatMap(attributes, function (attr) {
      if (mode) {
        return Belt_Option.flatMap(navMenuConfig, function (config) {
          return config.hamburgerTargetStyle;
        });
      } else {
        return Belt_Option.flatMap(navMenuConfig, function (config) {
          return config.topbarTargetStyle;
        });
      }
    });
  };
  var getTargetElement = function (param) {
    var partial_arg = document;
    return Belt_Option.map(Belt_Option.flatMap(getTargetSelector(mode), function (param) {
      return Caml_option.nullable_to_opt(partial_arg.querySelector(param));
    }), function (__x) {
      return WebapiUtils$Showside.$$Element.setAttribute(__x, "style", getTargetStyle(mode));
    });
  };
  var match$2 = React.useState(function () {
    return getTargetElement(undefined);
  });
  var setTargetElement = match$2[1];
  var targetElement = match$2[0];
  var canContinueWithoutInjection = Belt_Option.mapWithDefault(embedElement, false, function (el) {
    return Belt_Option.mapWithDefault(targetElement, false, function (el2) {
      return el2.contains(el);
    });
  });
  var documentReadyState = UseDocumentReadyStateChange$Showside.useDocumentReadyStateChange(undefined);
  var shouldReport = documentReadyState === /* Complete */2;
  var refreshTargetElement = function (forceUpdate, param) {
    var el = getTargetElement(undefined);
    if (el === undefined) {
      return;
    }
    var el$1 = Caml_option.valFromOption(el);
    Curry._1(setTargetElement, function (previousEl) {
      if (previousEl === undefined || forceUpdate) {
        return Caml_option.some(el$1);
      } else {
        return previousEl;
      }
    });
  };
  React.useEffect(function () {
    refreshTargetElement(true, undefined);
  }, [mode]);
  React.useEffect(function () {
    refreshTargetElement(false, undefined);
  }, [documentReadyState]);
  var observedSelector = mode ? Belt_Option.flatMap(navMenuConfig, function (config) {
    return config.hamburgerContainerTarget;
  }) : Belt_Option.flatMap(navMenuConfig, function (config) {
    return config.topbarContainerTarget;
  });
  var observedTarget = RefByQuerySelector$Showside.use(undefined, observedSelector);
  MutationObserver$Showside.use({
    attributes: true,
    characterData: false,
    childList: false,
    subtree: false
  }, observedTarget, function (param) {
    return refreshTargetElement(true, param);
  });
  var openNavMenu = function (param) {
    Belt_Option.forEach(Belt_Array.get(Belt_Array.keep(Belt_Array.keep(config.categories, function (category) {
      return category.visibleInMenuBar;
    }), function (category) {
      if (Category$Showside.hasAnyItems(category)) {
        return true;
      } else if (Category$Showside.isIndexNode(category)) {
        return isIndexAllowed;
      } else {
        return false;
      }
    }), 0), function (category) {
      Curry._3(goTo, undefined, undefined, {
        TAG: /* ListPage */1,
        _0: {
          listPageType: {
            TAG: /* Category */0,
            _0: category.id
          },
          viewPLP: false,
          filters: undefined,
          sort: undefined
        }
      });
    });
  };
  React.useEffect(function () {
    if (NavMenu__PreloadHelpers$Showside.getMenuOpened(undefined)) {
      openNavMenu(undefined);
    }
  }, []);
  var handleTriggerButtonClick = function (e) {
    e.stopImmediatePropagation();
    openNavMenu(undefined);
  };
  React.useEffect(function () {
    var selector = getTriggerButtonSelector(mode);
    if (selector === undefined) {
      return;
    }
    var elements = Belt_Array.keepMap(Array.prototype.slice.call(document.querySelectorAll(selector)), Webapi__Dom__Element.ofNode);
    Belt_Array.forEach(elements, function (element) {
      WipeDOMEvents$Showside.wipeDOMEvents(element).addEventListener("click", handleTriggerButtonClick);
    });
    return function (param) {
      Belt_Array.forEach(elements, function (element) {
        element.removeEventListener("click", handleTriggerButtonClick);
      });
    };
  }, [mode]);
  return {
    targetSelector: getTargetSelector(mode),
    targetElement: targetElement,
    canContinueWithoutInjection: canContinueWithoutInjection,
    shouldReport: shouldReport
  };
}
function NavMenuEntrypoint$CustomScripts(Props) {
  var attributes = Props.attributes;
  var navMenuConfig = NavMenu__Settings$Showside.useSettings(attributes);
  var injectCSS = Belt_Option.flatMap(navMenuConfig, function (config) {
    return config.injectCSS;
  });
  var injectJS = Belt_Option.flatMap(navMenuConfig, function (config) {
    return config.injectJS;
  });
  return React.createElement(React.Fragment, undefined, React.createElement(ConditionalRender$Showside.OptionMap.make, {
    option: injectCSS,
    children: function (css) {
      return React.createElement(InjectCSS$Showside.make, {
        css: css
      });
    }
  }), React.createElement(ConditionalRender$Showside.OptionMap.make, {
    option: injectJS,
    children: function (js) {
      return React.createElement(InjectJS$Showside.make, {
        js: js
      });
    }
  }));
}
NavMenuEntrypoint$CustomScripts.displayName = "NavMenuEntrypoint.CustomScripts";
var CustomScripts = {
  make: NavMenuEntrypoint$CustomScripts
};
function NavMenuEntrypoint$Content(Props) {
  var embedType = Props.embedType;
  var onOpenLink = Props.onOpenLink;
  var attributes = Props.attributes;
  var element = Props.element;
  var match = ConfigurationProvider$Showside.use(undefined);
  var setBreakpointOverride = match.setBreakpointOverride;
  var config = match.config;
  var match$1 = ViewportContext$Showside.use(undefined);
  var windowWidth = match$1.windowSize.width;
  var match$2 = RouterProvider$Showside.useRouter(undefined);
  var setIsHistoryEnabled = match$2.setIsHistoryEnabled;
  var previewMode = match$2.previewMode;
  var isStyleLoaded = CriticalCSSProvider$Showside.useIsStyleLoaded(undefined);
  var navMenuConfig = NavMenu__Settings$Showside.useSettings(attributes);
  var mode = Belt_Option.map(Belt_Option.flatMap(navMenuConfig, function (config) {
    return config.breakpointMaxWidth;
  }), function (maxWidth) {
    if (maxWidth > windowWidth) {
      return /* Hamburger */1;
    } else {
      return /* Topbar */0;
    }
  });
  var isTopbarEnabled = Belt_Option.getWithDefault(Belt_Option.map(navMenuConfig, function (config) {
    return config.topbarEnabled;
  }), true);
  var mode$1 = isTopbarEnabled ? Belt_Option.getWithDefault(mode, /* Topbar */0) : /* Hamburger */1;
  var breakpointOverride = Belt_Option.mapWithDefault(navMenuConfig, true, function (settings) {
    return settings.topbarEnabled;
  }) ? undefined : /* Sm */1;
  React.useEffect(function () {
    Curry._1(setBreakpointOverride, function (param) {
      return breakpointOverride;
    });
    Curry._1(setIsHistoryEnabled, function (clearIntent, previewMode, route) {
      if (mode$1) {
        return true;
      }
      if (clearIntent) {
        return true;
      }
      if (typeof route !== "number") {
        switch (route.TAG | 0) {
          case /* PDP */2:
          case /* QuickView */3:
            return true;
          default:
        }
      }
      if (previewMode !== undefined) {
        if (typeof previewMode === "number") {
          return previewMode === 0;
        } else {
          return true;
        }
      } else {
        return false;
      }
    });
  }, [mode$1]);
  var isIndexAllowed = mode$1 ? Belt_Option.mapWithDefault(navMenuConfig, false, function (config) {
    return config.hamburgerHomeEnabled;
  }) : Belt_Option.mapWithDefault(navMenuConfig, false, function (config) {
    return config.topbarHomeEnabled;
  });
  var match$3 = useTarget(attributes, element, mode$1, isIndexAllowed, undefined);
  var shouldReport = match$3.shouldReport;
  var targetElement = match$3.targetElement;
  var targetSelector = match$3.targetSelector;
  var zIndex = mode$1 ? Belt_Option.getWithDefault(Belt_Option.flatMap(navMenuConfig, function (config) {
    return config.hamburgerZIndex;
  }), NavMenu__Types$Showside.emptyCtx.zIndex) : Belt_Option.getWithDefault(Belt_Option.flatMap(navMenuConfig, function (config) {
    return config.topbarZIndex;
  }), NavMenu__Types$Showside.emptyCtx.zIndex);
  var threeColumnLayout = mode$1 ? false : Belt_Option.getWithDefault(Belt_Option.flatMap(navMenuConfig, function (config) {
    return config.topbarThreeColumnLayout;
  }), NavMenu__Types$Showside.emptyCtx.threeColumnLayout);
  var isModalOpen;
  var tmp = match$2.route;
  isModalOpen = typeof tmp === "number" || tmp.TAG === /* Home */0 ? false : true;
  var tmp$1 = {
    embedType: embedType
  };
  if (onOpenLink !== undefined) {
    tmp$1.onOpenLink = Caml_option.valFromOption(onOpenLink);
  }
  if (attributes !== undefined) {
    tmp$1.attributes = Caml_option.valFromOption(attributes);
  }
  var tmp$2 = {
    className: CSS$Showside.prefix("h-full"),
    children: React.createElement(NavMenu__Context$Showside.Provider.make, {
      value: {
        mode: mode$1,
        currentFullPath: NavMenu__Types$Showside.emptyCtx.currentFullPath,
        currentL1: NavMenu__Types$Showside.emptyCtx.currentL1,
        currentL2: NavMenu__Types$Showside.emptyCtx.currentL2,
        currentL3: NavMenu__Types$Showside.emptyCtx.currentL3,
        pageFlipTransitionSpeedMs: NavMenu__Types$Showside.emptyCtx.pageFlipTransitionSpeedMs,
        modalTransitionSpeedMs: NavMenu__Types$Showside.emptyCtx.modalTransitionSpeedMs,
        modalBackdropHeight: NavMenu__Types$Showside.emptyCtx.modalBackdropHeight,
        modalBackdropOpacity: NavMenu__Types$Showside.emptyCtx.modalBackdropOpacity,
        modalMaxWidth: NavMenu__Types$Showside.emptyCtx.modalMaxWidth,
        zIndex: zIndex,
        maxLevels: NavMenu__Types$Showside.emptyCtx.maxLevels,
        positions: NavMenu__Types$Showside.emptyCtx.positions,
        threeColumnLayout: threeColumnLayout,
        isModalOpen: isModalOpen,
        isIndexAllowed: isIndexAllowed
      },
      children: React.createElement(ConditionalRender$Showside.When.make, {
        condition: isStyleLoaded,
        children: React.createElement(StoreProvider$Showside.make, {
          config: config,
          children: React.createElement(LCPContext$Showside.Provider.make, {
            children: React.createElement(NavMenuApp$Showside.make, tmp$1)
          })
        })
      })
    })
  };
  if (attributes !== undefined) {
    tmp$2.attributes = Caml_option.valFromOption(attributes);
  }
  var content = React.createElement(BaseWithTheme$Showside.make, {
    initiator: "nav-menu",
    style: {
      height: "100%",
      width: "100%"
    },
    className: CSS$Showside.prefix("text-inherit"),
    portal: false,
    children: null
  }, React.createElement(AdditionalCSS$Showside.make, {
    embedType: embedType
  }), React.createElement(ConditionalRender$Showside.When.make, {
    condition: Caml_obj.notequal(previewMode, /* PreviewLive */1) && previewMode !== undefined,
    children: React.createElement(EditorMethods$Showside.make, {})
  }), React.createElement(UserSavedProductsProvider$Showside.make, {
    configId: config.id,
    accountId: config.accountId,
    historyEnabled: config.settings.historyEnabled,
    favoritesEnabled: config.settings.favoritesEnabled,
    children: React.createElement(CartContextProvider$Showside.make, {
      children: React.createElement(StickyHeaderOffsetProvider$Showside.make, tmp$2)
    })
  }));
  if (match$3.canContinueWithoutInjection) {
    return content;
  }
  var node;
  if (targetSelector !== undefined) {
    if (targetElement === undefined) {
      return React.createElement(BaseWithTheme$Showside.make, {
        initiator: "nav-menu",
        portal: false,
        children: React.createElement(ErrorReporter$Showside.make, {
          error: RollbarInstance$Showside.makeError(shouldReport, "Nav Menu: Failed to find a target element with query selector \`" + targetSelector + "\` for " + (mode$1 ? "hamburger" : "topbar") + "."),
          extraInfo: {
            querySelector: targetSelector
          }
        })
      });
    }
    node = Caml_option.valFromOption(targetElement);
  } else {
    if (targetElement === undefined) {
      return React.createElement(BaseWithTheme$Showside.make, {
        initiator: "nav-menu",
        portal: false,
        children: React.createElement(ErrorReporter$Showside.make, {
          error: RollbarInstance$Showside.makeError(shouldReport, "Nav Menu: No target element is configured for " + (mode$1 ? "hamburger" : "topbar") + ".")
        })
      });
    }
    node = Caml_option.valFromOption(targetElement);
  }
  return React.createElement(PortalEmptying$Showside.make, {
    node: node,
    children: content
  });
}
NavMenuEntrypoint$Content.displayName = "NavMenuEntrypoint.Content";
var make = React.memo(NavMenuEntrypoint$Content);
var Content = {
  make: make
};
function NavMenuEntrypoint$MenuEntrypoint(Props) {
  var configId = Props.configId;
  var embedTypeOpt = Props.embedType;
  var attributes = Props.attributes;
  var element = Props.element;
  var trackers = Props.trackers;
  var onAddToCart = Props.onAddToCart;
  var onOpenLink = Props.onOpenLink;
  var embedType = embedTypeOpt !== undefined ? embedTypeOpt : /* Bottombar */0;
  var attributes$1 = EmbedTypes$Showside.Attributes.useAttributesObserver(element, attributes);
  var namespace = EmbedTypes$Showside.getNamespace(attributes$1);
  var accountId = Belt_Option.flatMap(attributes$1, function (attr) {
    return attr.account;
  });
  var navMenuConfig = NavMenu__PreloadHelpers$Showside.getSettings(undefined, undefined);
  var breakpointOverride = Belt_Option.mapWithDefault(navMenuConfig, true, function (settings) {
    return settings.topbarEnabled;
  }) ? undefined : /* Sm */1;
  React.useEffect(function () {
    if (!ShopifyAnalytics$Showside.isProductPage(undefined)) {
      PictureInPicture2SessionStorage$Showside.clearLastCategory(undefined);
    }
  }, []);
  var tmp = {};
  if (attributes$1 !== undefined) {
    tmp.attributes = Caml_option.valFromOption(attributes$1);
  }
  var tmp$1 = {
    embedType: embedType,
    configId: configId
  };
  if (onOpenLink !== undefined) {
    tmp$1.onOpenLink = Caml_option.valFromOption(onOpenLink);
  }
  if (attributes$1 !== undefined) {
    tmp$1.attributes = Caml_option.valFromOption(attributes$1);
  }
  if (element !== undefined) {
    tmp$1.element = Caml_option.valFromOption(element);
  }
  var tmp$2 = {
    configId: configId,
    children: React.createElement(NavSDK$Showside.Provider.make, {
      children: null
    }, React.createElement(NavMenuEntrypoint$CustomScripts, tmp), React.createElement(make, tmp$1)),
    enableTrimmingTreeByReferrer: false
  };
  if (breakpointOverride !== undefined) {
    tmp$2.breakpointOverride = Caml_option.valFromOption(breakpointOverride);
  }
  var tmp$3 = {
    children: React.createElement(CriticalCSSProvider$Showside.make, CriticalCSSProvider$Showside.makeProps(React.createElement(ExternalIntegrationProvider$Showside.make, {
      value: {
        accountId: accountId,
        trackers: trackers,
        onAddToCart: onAddToCart,
        onOpenLink: onOpenLink
      },
      children: React.createElement(ViewportContext$Showside.Provider.make, {
        children: React.createElement(RouterProvider$Showside.make, {
          configId: configId,
          embedType: embedType,
          children: React.createElement(ConfigurationProvider$Showside.make, tmp$2)
        })
      })
    }), undefined, undefined))
  };
  if (namespace !== undefined) {
    tmp$3.namespace = Caml_option.valFromOption(namespace);
  }
  return React.createElement(React.StrictMode, {
    children: React.createElement(LocationConfig$Showside.Provider.make, tmp$3)
  });
}
NavMenuEntrypoint$MenuEntrypoint.displayName = "NavMenuEntrypoint.MenuEntrypoint";
var MenuEntrypoint = {
  make: NavMenuEntrypoint$MenuEntrypoint
};
function render(configId, onOpenLink, onAddToCart, trackers, isLauncher, element, attributes) {
  var elementId = element.id;
  var newDictEntry = [[elementId, element]];
  var attributes$1 = Belt_Option.map(attributes, function (attr) {
    return attr.attributes;
  });
  var elements = window.smartNavElementsMenu;
  var prim1 = Belt_Option.mapWithDefault(elements, Js_dict.fromArray(newDictEntry), function (elements) {
    return Js_dict.fromArray(Belt_Array.concat(Js_dict.entries(elements), newDictEntry));
  });
  var prim0 = window;
  prim0.smartNavElementsMenu = prim1;
  var tmp = {
    configId: configId,
    embedType: /* Menu */4,
    element: element,
    key: configId
  };
  if (attributes$1 !== undefined) {
    tmp.attributes = Caml_option.valFromOption(attributes$1);
  }
  if (trackers !== undefined) {
    tmp.trackers = Caml_option.valFromOption(trackers);
  }
  if (onAddToCart !== undefined) {
    tmp.onAddToCart = Caml_option.valFromOption(onAddToCart);
  }
  if (onOpenLink !== undefined) {
    tmp.onOpenLink = Caml_option.valFromOption(onOpenLink);
  }
  ReactDOMUtils$Showside.render(React.createElement(ErrorBoundary$Showside.make, {
    componentName: "Root",
    children: React.createElement(NavMenuEntrypoint$MenuEntrypoint, tmp)
  }), element);
}
function goTo(quickView, quickNav, replaceState, preserveScroll, namespace) {
  Location$Showside.goTo(namespace, undefined, quickView, quickNav, replaceState, preserveScroll, undefined);
}
async function initSmartnav(index, element) {
  EmbedTypes$Showside.Attributes.autoAssignNamespaces(undefined);
  var attributes = EmbedTypes$Showside.Attributes.fromElement(element);
  var configId = await ConfigIdGetter$Showside.getConfigId(undefined, undefined, false, attributes, /* Menu */4);
  if (configId !== undefined) {
    return render(configId, undefined, undefined, undefined, false, element, {
      embedType: /* Menu */4,
      attributes: attributes
    });
  }
}
function init(param) {
  var element = document.querySelector("#maker-smartnav-menu");
  if (element == null) {
    console.error("Could not initialize SmartNav: no element found");
  } else {
    initSmartnav(0, element);
  }
}
export { useTarget, CustomScripts, Content, MenuEntrypoint, render, goTo, initSmartnav, init };
/* make Not a pure module */